/* SnelplannerSuggesties — AI-gerankte medewerker-suggestielijst.
   Extracted uit RoosterPage.jsx (feb 2026 split). */
import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export function SnelplannerSuggesties({ datum, groupId, onAdd, refreshKey }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let cancel = false;
    api.get("/planning/suggesties", { params: { datum, group_id: groupId } })
      .then(r => { if (!cancel) setRows(r.data?.suggesties || []); })
      .catch(() => { if (!cancel) setRows([]); });
    return () => { cancel = true; };
    // `api` is stabiele module-level import.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datum, groupId, refreshKey]);

  if (rows === null) return null;
  if (rows.length === 0) {
    return (
      <div className="border-t border-red-200 bg-red-50/40 px-3 py-2 text-[11px] text-red-800" data-testid="snelplanner-empty">
        Geen gekwalificeerde PMs met open uren beschikbaar voor deze locatie.
        Controleer contracten of markeer meer medewerkers als gediplomeerd.
      </div>
    );
  }

  return (
    <div className="border-t border-neutral-200 bg-white" data-testid="snelplanner-panel">
      <div className="px-3 pt-2 pb-1 flex items-center gap-2 flex-wrap">
        <span className="text-[10px] uppercase tracking-widest font-semibold text-neutral-700">
          Snelplanner · AI-ranking
        </span>
        <span className="text-[10px] text-neutral-500">
          gediplomeerd · gekoppeld · open contract-uren
        </span>
        {rows[0]?.match_redenen && rows[0].match_redenen.length > 0 && (
          <span className="text-[10px] text-blue-700 ml-auto">
            top match: {rows[0].match_redenen.join(" · ")}
          </span>
        )}
      </div>
      <div className="px-3 pb-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {rows.slice(0, 6).map((s, idx) => (
          <div key={s.medewerker_id}
               className={`flex items-center justify-between gap-2 border rounded p-2 hover:bg-neutral-50 ${idx === 0 ? "border-[color:var(--sage,#0d5e4a)] bg-emerald-50/30" : "border-neutral-200"}`}
               data-testid={`snelplanner-row-${s.medewerker_id}`}>
            <div className="min-w-0">
              <div className="text-sm font-medium truncate flex items-center gap-1">
                {idx === 0 && <span className="text-[9px] font-bold uppercase tracking-widest text-[color:var(--sage,#0d5e4a)]">#1</span>}
                {s.naam}
              </div>
              <div className="text-[10px] text-neutral-600 flex items-center gap-1 flex-wrap">
                <span className="tabular-nums">{s.open_uren}u open</span>
                <span className="text-neutral-400">·</span>
                <span className="tabular-nums">{s.ingeplande_uren_week}/{s.contract_uren}u</span>
                {s.heeft_ehbo && <span className="text-emerald-700 ml-1">EHBO</span>}
                {s.voorkeur_opener && <span className="text-blue-700 ml-1">opener</span>}
                {s.voorkeur_sluiter && <span className="text-blue-700 ml-1">sluiter</span>}
              </div>
              {s.match_redenen && s.match_redenen.length > 0 && (
                <div className="text-[9px] text-blue-700 mt-0.5" data-testid={`snelplanner-redenen-${s.medewerker_id}`}>
                  ★ {s.match_redenen.join(" · ")}
                </div>
              )}
            </div>
            <button
              onClick={() => onAdd(s.medewerker_id)}
              data-testid={`snelplanner-add-${s.medewerker_id}`}
              className="text-[11px] font-medium px-2 py-1 rounded bg-[color:var(--sage,#0d5e4a)] text-white hover:opacity-90 shrink-0"
            >
              + Inplannen
            </button>
          </div>
        ))}
      </div>
      {rows.length > 6 && (
        <div className="px-3 pb-2 text-[10px] text-neutral-500">
          + nog {rows.length - 6} andere beschikbare PMs — voeg via reguliere shift-dialoog toe.
        </div>
      )}
    </div>
  );
}
